class Concerns.Destroy

  assignElements: ->
    @$repeatButton     = $('.js-repeat')
    @$replaceSelects   = $('select.js-replace')
    @$allReplaceSelect = $('select.all-replace')

  assignEvents: ->
    self = @

    @$repeatButton.click ->
      self.submit $(@)

    @$allReplaceSelect.change =>
      value = @$allReplaceSelect.val()
      return if value == 'none'

      @$replaceSelects.each ->
        UI.setSelectValue(@, value)

    @$replaceSelects.change =>
      @normalizeAllReplaceSelect()

  constructor: ->
    @assignElements()
    @assignEvents()

    @href = @$repeatButton.attr('href')

  submit: ($button) ->
    self   = @
    params = []
    joiner = if @href.indexOf('?') < 0 then '?' else '&'

    @$replaceSelects.each ->
      value = $(@).val()
      name  = $(@).attr('name')

      return if value == 'skip'
      params.push "replacements[#{encodeURIComponent name}]="+encodeURIComponent(value)

    $button.attr 'href', @href + joiner + params.join('&')

  normalizeAllReplaceSelect: ->
    data = _.unique @$replaceSelects.map(-> $(@).val()).toArray()

    if data.length > 1
      UI.setSelectValue(@$allReplaceSelect, "none")
    else
      UI.setSelectValue(@$allReplaceSelect, data[0])
